import React from 'react';

/**
 * EditorToolbarButton — extracted from ContentEditor.jsx (Phase 9 refactor).
 * Single reusable icon button for the editor formatting toolbar.
 * Zero logic changes.
 */
const EditorToolbarButton = ({ icon: Icon, label, onClick, disabled, active, tooltip, showLabel }) => (
    <button
        className={`toolbar-btn ${active ? 'active' : ''} ${disabled ? 'disabled' : ''} ${showLabel ? 'has-label' : ''}`}
        onMouseDown={(e) => {
            e.preventDefault(); // Prevent focus loss
            if (!disabled) onClick();
        }}
        title={tooltip || label}
        disabled={disabled}
    >
        <Icon size={16} />
        {showLabel && <span className="btn-label-text">{label}</span>}
        <span className="toolbar-tooltip">{tooltip || label}</span>
    </button>
);

export default EditorToolbarButton;
